window.easyZoomIsActive = false;

PNotify.prototype.options.styling = "bootstrap3";

var lastViewport    = null;

// Iniciando funções para todas as páginas
$(function() {

    /**
     *  Ajusta os icones no menu
     *  - Chama a função ajustmentMenu();
     */
    menuIcone();
    $(window).resize(function() {
        menuIcone();
    });

    /**
     * Identifica e define o alias relacionado à resolução da tela
     */
    identifyPage();

    /**
     * Inicializa o lazyload para as imagens
     */
    initLazyLoad();

    /**
     * Inicializa o plugin picturefill utilizado nos banners da home
     */
    initPicture();
});


$(window).load(function(){

    var $loadBody = $('body');

    /**
     * Inicializa o plugin de quantidade de colunas apenas nas páginas:
     * - produtos
     * - busca
     */
    if (['produtos', 'search'].indexOf(pageName) > -1)
    {
        changeCookieGridOrList();
        initFormFilterProduct();
    }

    if (['home'].indexOf(pageName) > -1)
    {
        initBannerBlocksHome();
    }

    /**
     * Adiciona o evento click nos links do menu principal para carregar a página com base no href
     */
    $('.dropdown a').on('click', function(e){
        window.location.href = $(this).attr('href');
        e.preventDefault();
        return false;
    });

    buttonAviseme();
    if ($('.btn-open-quickview').length > 0) {
        hoverProduto();
    }
    $(window).resize(function() {
        buttonAviseme();
        if ($('.btn-open-quickview').length > 0) {
            hoverProduto();
        }
    });


    var nav                 = '#menu-desktop nav';
    var submenu             = '#menu-desktop .open .dropdown-menu';

    // Usando a classe "dropdown-hover" pra abrir o dropdown no hover (ah vá)
    $('.dropdown').hover(function(){
        $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).slideDown("400");
        $(this).toggleClass('open');
        var navOffsetRight      = $(window).width() - ($(nav).offset().left + $(nav).outerWidth());
        var navOffsetLeft       = $(nav).offset().left;
        var submenuOffsetLeft   = $(submenu).offset() != undefined ? $(submenu).offset().left : 0;
        var submenuOffsetRight  = $(window).width() - (submenuOffsetLeft + $(submenu).outerWidth());

        if(navOffsetRight > submenuOffsetRight){
            $(submenu).addClass('dropdown-menu-right');
            if(navOffsetLeft > $(submenu).offset().left) {
                var submenuAlign = '-' + ($(submenu).innerWidth() / 2) + 'px';
                $(submenu).removeClass('dropdown-menu-right').css('margin-left','50%').css('left', submenuAlign);
            }
        }
    }).mouseover(function() {
        $(this).addClass('open');
    }).mouseout(function() {
        $(this).removeClass('open');
    });

    /**
     * PhotoSwipe
     */
    $('[data-toggle="photoSwipe"]').on('click', function(e) {
        e.preventDefault();
        var items = [{
            src : $(this).attr('href'),
            w   : $(this).data('width'),
            h   : $(this).data('height'),
        }];
        var options = {
            history: false,
            focus: false,
            bgOpacity: 0.85,
        };
        openPhotoSwipe(items, options);
    });

    function openPhotoSwipe(items, options) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }

    /**
     *
     */

    $loadBody.on('submit', '#product-filters-wrapper .product-form-filter', function(e) {
        e.preventDefault();
        loadOnDisabledElement($(this).find('[type="submit"]'));
        var categoryUrl = window.request.basePath + window.request.pathInfo;
        var fields = $(this).serializeJSON();
        fields = clean_data(fields);
        var queryString = '?product-filter=' + encodeURIComponent(JSON.stringify(fields));
        window.location = categoryUrl + queryString;
        return false;
    });

    $loadBody.on('click', '#product-filters-wrapper  .btn.btn-limpar', function(){
        loadOnDisabledElement(this);
        var body = $(this).parents('.panel-collapse');
        body.find(':checkbox').attr('checked', false);
        body.find(':text').val('');
        body.parents('form').trigger('submit');
    });

    $loadBody.on('click', '#product-filters-wrapper  .list-variation li', function(){
        var cbox = $(this).find(':checkbox');
        cbox.prop("checked", !cbox.prop("checked"));
    });

    $loadBody.on('click', '#product-filters-wrapper .caracteristica-ver-mais', function() {
        $($(this).data('id') + ' ul li.hide').removeClass('hide').addClass('in');
        $(this).addClass('hide');
        $(this).next().removeClass('hide');
    });
    $loadBody.on('click', '#product-filters-wrapper .caracteristica-ver-menos', function() {
        $($(this).data('id') + ' ul li.in').removeClass('in').addClass('hide');
        $(this).addClass('hide');
        $(this).prev().removeClass('hide');
    });

    /**
     * Modal filters
     */
    var modalFilters = $("#modal-filters");
    var filtrosCarregados = false;
    modalFilters.on('show.bs.modal', function () {
        setTimeout( function() {
            if (filtrosCarregados == false) {
                var modalFiltersBody = $('#modal-filters .modal-body');
                filtrosCarregados = true;
                modalFiltersBody.html($('#product-filters-aside').html());
            }
            $(".modal-backdrop").addClass("modal-backdrop-fullscreen");
        }, 0);
    });

    modalFilters.on('hidden.bs.modal', function () {
        $(".modal-backdrop").addClass("modal-backdrop-fullscreen");
    });

    /**
     * Formulário de newsletter
     */
    $('.form-newsletter input').on('keypress', function(e) {
        return e.which !== 13;
    });
    var $centerFormNewsletterTop = $('.form-newsletter');
    $centerFormNewsletterTop.on('click', '.fnGenderNewsletter', function(e) {
        $centerFormNewsletterTop.find('[name="newsletter[sexo]"]').val($(this).data('gender'));
    });

    var sourceSwap = function () {
        var $this = $(this);
        var newSource = $this.data('alt-src');
        $this.data('alt-src', $this.attr('src'));
        $this.attr('src', newSource);
    };

    $('img[data-alt-src]').hover(sourceSwap, sourceSwap);

    /**
     * Valida o campo CPF e apresenta mensagem se estiver errado
     */
    $('.validity-cpf').on('change', function() {
        if ($(this).val().length == 14) {
            var isValid = isValidCpf($(this).val());
            if (!isValid) {
                $(this).addClass('tooltip-danger');
                $(this).tooltip({
                    title: "CPF inválido!",
                    trigger: 'manual'
                }).tooltip('show');
            } else {
                $(this).removeClass('tooltip-danger');
                $(this).tooltip('destroy');
            }
        } else {
            $(this).tooltip('destroy');
        }
    });

    /**
     * Valida o campo CNPJ e apresenta mensagem se estiver errado
     */
    $('.validity-cnpj').on('change', function() {
        if ($(this).val().length > 0) {
            var isValid = isValidCnpj($(this).val());
            if (!isValid) {
                $(this).tooltip({
                    title: "CNPJ inválido!",
                    trigger: 'manual'
                }).tooltip('show');
            } else {
                $(this).tooltip('destroy');
            }
        } else {
            $(this).tooltip('destroy');
        }
    });

    /**
     * Valida o campo EMAIL e apresenta mensagem se estiver errado
     */
    $('.verify-unique-email').on('change', function() {
        var $field = $(this);

        if ($field.val().length > 0) {

            $.getJSON(window.request.baseUrl + '/ajax/unique-email', {email: $field.val() })
                .done(function(response) {
                    if (response.emailAlreadyRegistered) {
                        $field.tooltip({
                            title: "E-mail já cadastrado",
                            trigger: 'manual'
                        }).tooltip('show');
                    } else {
                        $field.tooltip('destroy');
                    }
                });
        } else {
            $field.tooltip('destroy');
        }
    });

    lastViewport = identifyScreen();

    // Evento para conferir quando alguma visualização não está visivel com base no tamanho da tela
    $(window).on('resize',function() {
        setTimeout(function() {
            if (lastViewport != identifyScreen()) {
                lastViewport = identifyScreen();
                changeCookieGridOrList();
            }
        }, 300)
    });

    // Evento para quando alterar a visualização
    $loadBody.on('click', '[data-products-visualization]:not(.active)', function(){
        if ($.inArray($(this).data('products-visualization'), getOptionsAvailable()) >= 0) {
            $('.product-list:not(.cross-selling-container):not(.product-list-carousel)').hide();
            $.cookie('products-visualization', $(this).data('products-visualization'), { expire: 30, path: '/' });
            gridOrList();
            setTimeout(function(){
                $('.product-list:not(.cross-selling-container):not(.product-list-carousel)').fadeIn();
            }, 100);
        }
    });


    $(window).resize(function() {
        initMenuMobile(['xs', 'sm']);
    });

    /**
     * Inicializa o menu mobile quando a resolusão estiver
     * definida como xs ou sm
     */
    initMenuMobile(['xs', 'sm']);

    /**
     *  Inicializa a busca sugestiva
     */
    if (['xs', 'sm'].indexOf(dataScreen) == -1) {
        suggestiveSearch();
    }
    $(window).resize(function() {
        if (['xs', 'sm'].indexOf(dataScreen) == -1) {
            suggestiveSearch();
        }
    });

    /**
     * Inicializa o plugin tooltip
     */
    $('[data-toggle="tooltip"]').tooltip();

    /**
     * Inicializa as máscaras utilizadas nos campos dos formulários
     */
    initMasks();

    initMaskMoney('.mask-money-product-filter', {
        allowZero: false,
        decimal: ',',
        thousands: '.'
    });

    /**
     * Atualiza o endereço com base no CEP informado
     */

    var lastSearch = null;

    $loadBody.on('keyup', '.register-cep', function() {
        if ($(this).val().length == 9 && $(this).val() != lastSearch) {
            lastSearch = $(this).val();
            var $form = $(this).closest('form');
            loadEndereco($(this).val(), {
                cep: $(this),
                endereco: $form.find('.register-street'),
                complemento: $form.find('.register-complement'),
                bairro: $form.find('.register-district'),
                numero: $form.find('.register-number'),
                estado: $form.find('.address-uf'),
                cidade: $form.find('.register-city')
            });
        }
    });

    $('.register-cep').closest('section').find('.register-street, .register-district, select').each(function() {
        if ($(this).val() != '') {
            $(this).attr('disabled', true);
        }
    })

    /**
     * Atualiza a cidade com base no estado selecionado
     */
    $loadBody.on('change', '.address-uf', function() {
        var $form = $(this).closest('form');
        loadCidades($(this).val(), $form.find('.register-city').parent(), null);
    });


    selectWithLinks();

    /**
     * Plugin do modal
     */
    initMagnificPopupModal();

    /**
     * Atualiza o dropdown do carrinho após alterar a quantidade de algum produto
     */
    loadCartQuantity();
    if (['md', 'lg', 'xl'].indexOf(dataScreen) > -1) {
        updateCartQuantity();
    }

    /**
     * Funções do scrolltop
     */
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 500) {
            $('.scrollTop').stop(true, true).css({ 'right': '-100px'}).animate({
                'right' : '20px'
            });
        } else {
            $('.scrollTop').stop(true, true).css({ 'right': '20px'}).animate({
                'right' : '-100px'
            });
        }
    });

    $('.scrollTop').on('click', function(e) {
        $('html, body').stop().animate({scrollTop: 0}, '300');
        return false;
    });

    /**
     * Mensagens de validação do html5
     */
    validity('.validity-default', 'Preenche este campo');
    validity('.validity-name', 'Informe seu nome');
    validity('.validity-email', 'E-mail inválido');
    validity('.validity-birthday', 'Data de nascimento inválida');
    validity('.validity-cpf', 'CPF inválido');
    validity('.validity-tel', 'Telefone inválido');
    validity('.validity-question', 'Informe sua dúvida');
    validity('.validity-city', 'Selecione uma cidade');
    validity('.validity-state', 'Selecione um estado');
    validity('.validity-neighborhood', 'Insira o nome do bairro');
    validity('.validity-number', 'Número inválido');
    validity('.validity-cep', 'CEP inválido');
    validity('.validity-password', 'A senha deve ter no mínimo 6 caracteres');
    validity('#name-card', 'Digite o nome exatamente como está impresso no cartão');

    /**
     * Ações de loading dos formulários
     */
    initFormDataActions();
    disableFormOnSubmit();
    removeLoaderFromElement('.form-disabled-on-load');
    initSlimScroll();

    hideLoader();

    setTimeout(initTouchSpin, 1500);

    initAdwordsForm();

    // if ($('#menu-desktop').hasClass('mudar-cor')) {
    //
    //     corPadrao();
    //
    //     $( "a.icon-top" ).hover(
    //         function() {
    //             alteraCor(this);
    //         }, function() {
    //             corPadrao(this);
    //         }
    //     );
    // }

    if( $("#xs-check").is(":visible") ) {
        $("#sobre-a-empresa-content").removeClass("in");
    }
    
    $loadBody.on('click', '[data-confirm="true"]', function(e) {
        e.preventDefault();
        
        var _this = $(this);

        var form = false;
        var urlLocation = false;

        if ($(_this).data('form') && $(_this).data('type') == 'submit') {
            form = $($(_this).data('form'));
        } else {
            urlLocation = $(_this).data('href');
        }
        
        var options = {
            title: $(_this).data('title') || 'Você tem certeza?',
            text: $(_this).data('text') || 'Você tem certeza que deseja continuar?',
            type: "warning",
            showCancelButton: true,

            confirmButtonClass: "btn btn-success btn-sm",
            cancelButtonClass: "btn btn-danger btn-sm",

            confirmButtonText: "Sim",
            cancelButtonText: "Não"
        };

        swal(options, function (isConfirm) {
            if (isConfirm) {
                loadOnDisabledElement(_this);
                if (form) {
                    form.trigger('submit');
                } else {
                    window.location = urlLocation;
                }
            }
        });
    })

});
